var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.heading
      ? _c("h3", {
          staticClass: "title is-6 column-title",
          domProps: { textContent: _vm._s(_vm.heading) },
        })
      : _vm._e(),
    _c("div", { class: { box: _vm.boxed } }, [
      _vm.data
        ? _c("div", { staticClass: "content" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.content) } }),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }